export default "__VITE_ASSET__C$HoaR$3__"